import { LOGOS } from "../../lib/brand";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Mission", href: "#mission" },
  { label: "Experience", href: "#experience" },
  { label: "Moments", href: "#moments" },
];

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="relative w-full"
      style={{ backgroundColor: "#634F50" }}
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14">
        {/* Row 1: nav left (hidden on mobile), waitlist right */}
        <div
          className="flex items-center justify-between md:justify-between h-9 md:h-10 -mx-6 md:-mx-10 lg:-mx-14 px-6 md:px-10 lg:px-14"
          style={{ backgroundColor: "rgba(43, 35, 32, 0.18)" }}
        >
          {/* Desktop nav links */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-10 flex-wrap">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="eyebrow text-[#F6F2EC] transition-opacity hover:opacity-60"
              >
                {l.label}
              </a>
            ))}
          </nav>

          {/* Mobile: nothing on the left, waitlist sits flush left */}
          <div className="md:hidden" aria-hidden="true" />

          <a
            href="https://tally.so/r/VLv7Ey"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-waitlist-cta"
            className="eyebrow text-[#F6F2EC] transition-opacity hover:opacity-60 whitespace-nowrap"
          >
            Join the Waitlist
          </a>
        </div>

        {/* Row 2: large centered logo — primary brand anchor */}
        <a
          href="#top"
          data-testid="header-logo-link"
          aria-label="Musemi"
          className="block"
        >
          {/* Aspect-ratio wrapper using padding-bottom trick — reliable on every browser including iOS Safari */}
          <div className="mx-auto w-full max-w-[280px] sm:max-w-[340px] md:max-w-[380px] py-2 md:py-3">
            <div className="relative w-full" style={{ paddingBottom: "20%" }}>
              <img
                src={LOGOS.cream}
                alt="Musemi"
                data-testid="header-logo-img"
                className="absolute inset-0 w-full h-full"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
          </div>
        </a>
      </div>
    </header>
  );
};
